module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', [_c('div', {
    staticClass: "columns is-desktop"
  }, [_c('div', {
    staticClass: "column is-one-third is-offset-one-third"
  }, [_c('section', {
    staticClass: "mt-4"
  }, [_c('h1', {
    staticClass: "title is-2"
  }, [_vm._v("Create New Password")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.reset()
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_password1),
      expression: "new_password1"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "new password",
      "required": ""
    },
    domProps: {
      "value": (_vm.new_password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_password1 = $event.target.value
      }
    }
  })]), _vm._l((_vm.newPassword1Erorrs), function(error) {
    return _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(error))])
  }), _vm._v(" "), _c('p')], 2), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Password (Again)")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_password2),
      expression: "new_password2"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "new password",
      "required": ""
    },
    domProps: {
      "value": (_vm.new_password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_password2 = $event.target.value
      }
    }
  })]), _vm._l((_vm.newPassword2Erorrs), function(error) {
    return _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(error))])
  }), _vm._v(" "), _c('p')], 2), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: _vm.loading && 'is-loading',
    attrs: {
      "type": "submit",
      "disabled": !_vm.valid
    }
  }, [_vm._v("Create New Password")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-4f5c9054"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmPasswordReset.vue
// module id = 1033
// module chunks = 0